import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EnvironmentInjector,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  BehaviorSubject,
  Observable,
  Subject,
  lastValueFrom,
  map,
  take,
  takeUntil,
} from 'rxjs';
import {
  LanguagePdfGenerator,
  PdfFormat,
} from '../../../interfaces/pdfGenerators.interface';

import { PDFOptions } from 'puppeteer';

import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { LOCALES_CODES } from 'apps/desktop/src/app/locales/locales';
import { PdfService } from 'apps/desktop/src/app/pdf/pdf.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { downloadFile, generatePdf, printPdf } from '../pdf.pure';

@Component({
  selector: 'etoh-pdf-user-generator',
  templateUrl: './pdf-user-generator.component.html',
  styleUrls: ['./pdf-user-generator.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    NzSelectModule,
    FormsModule,
    NzButtonModule,
    NzSpinModule,
    FlexLayoutModule,
  ],
})
export class PdfUserGeneratorComponent implements OnInit {
  @Input() languages: LanguagePdfGenerator[];

  @Input() selectedLanguage = 'en';
  @Output() selectLanguage = new Subject<string>();

  @Input() pdfName: string | null;

  @Input() formats: PdfFormat<any>[];

  @Input() locale?: LOCALES_CODES;

  @Input() data$: Observable<any>;

  @Input() url: 'agreements' | 'samples' | 'sampleShipments';

  loading$ = new BehaviorSubject<string[]>([]);

  destroy$ = new Subject();

  constructor(
    private http: HttpClient,
    private cd: ChangeDetectorRef,
    private message: NzMessageService,
    private injector: EnvironmentInjector,
    private pdfService: PdfService
  ) {}

  ngOnInit(): void {
    this.data$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // this.loading$.next([]);
      this.cd.detectChanges();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    // this.loading$.next([]);
    // TODO: should reset loading only if format changes
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  public async downloadPdf(type: 'print' | 'download', pdfOptions: PDFOptions) {
    console.log('data', type, pdfOptions);

    const data = await lastValueFrom(this.data$.pipe(take(1)));

    console.log('data', type, pdfOptions);

    const formatForLoading = this.getFormatLoading(
      type,
      this.selectedLanguage,
      pdfOptions
    );

    const oldLoading = this.loading$.value;
    const newLoading = [...oldLoading, formatForLoading];
    this.loading$.next(newLoading);
    this.cd.detectChanges();

    console.log('data', type, pdfOptions);

    this.injector.runInContext(() => {
      generatePdf(this.pdfService.apiUrl, this.url, data, pdfOptions, {
        locale: this.locale,
        lang: this.selectedLanguage,
      }).subscribe(
        (data: any) => {
          console.log('data', type, pdfOptions);

          if (type === 'print') {
            printPdf(data);
          } else {
            downloadFile(data, `${this.pdfName}.pdf`);
          }

          let olddLoading = this.loading$.value;
          olddLoading = olddLoading.filter((l) => l !== formatForLoading);
          this.loading$.next(olddLoading);
          this.cd.detectChanges();
        },
        (err) => {
          console.log('err', err);
          this.message.error(err?.message);
        }
      );
    });
  }

  isFormatLoading(type: string, pdfOptions: PDFOptions): Observable<boolean> {
    return this.loading$.pipe(
      map((loadingFormats) => {
        return loadingFormats.includes(
          this.getFormatLoading(type, this.selectedLanguage, pdfOptions)
        );
      })
    );
  }

  public getFormatLoading(type: string, lang: string, format: PDFOptions) {
    const f = JSON.stringify(format);
    return `${type}-${f}-${lang}`;
  }
}
